import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoDrawer } from "@disco-ui"
import lazyWithRetry from "@utils/lazy/lazyWithRetry"

const AICanvasDrawerContent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ai-canvas-drawer-content" */ "@/content/ai/drawer/AICanvasDrawerContent"
    )
)

export default function AICanvasDrawer() {
  const drawer = useGlobalDrawer("aiCanvas")
  const classes = useStyles()

  return (
    <DiscoDrawer
      open={drawer.isOpen}
      size={"xxl"}
      fullScreen
      onClose={drawer.close}
      containerClasses={{ drawerContainer: classes.drawer }}
    >
      {drawer.isOpen && <AICanvasDrawerContent />}
    </DiscoDrawer>
  )
}

const useStyles = makeUseStyles({
  drawer: {
    padding: 0,
    display: "grid",
    gridTemplateRows: "1fr max-content",
    overflow: "hidden",
  },
})
